// import ajax from './ajax'
//import Vue from 'vue'
import axios from './http'
// import Vue from 'vue'



export default {
    // getUser(){
    //     return axios.get('/user')
    //     .then(function (response) {
    //         // console.log("createCampaign then")
    //         return Promise.resolve(response.data)
    //     })
    //     .catch(function (error) {
    //         return Promise.reject(error)
    //     });
    // },
    login(email, password, type, portal){
        return axios.post('/login', {'email':email,'password':password, type: type, 'channel':portal})
        .then(function (response) {
            // console.log(response)
            return Promise.resolve(response)
        })
        .catch(function (error) {
            return Promise.reject(error)
        });
        // console.log(axios.get('/user'));

        // return;
        // return this.$http.post('/login', {'email':email,'password':password})
        // .then(function (response) {
        //     // console.log("createCampaign then")
        //     return Promise.resolve(response.data)
        // })
        // .catch(function (error) {

        //     // if (!error.response) {
        //     //     return Promise.reject('Error: Network Error')
        //     //       // network error
        //     //       //this.errorMessage = 'Error: Network Error';
        //     // } else {
        //         return Promise.reject(error)
        //     // }
        //     //console.log(error);
        //     // console.log("createCampaign catch")
        //     //return Promise.reject(error.response)
        // });
    },
    resetPassword(email){
        axios.post('/resetpassword', {'email':email})
        .then(function (response) {
            // console.log("createCampaign then")
            return Promise.resolve(response.data)
        })
        .catch(function (error) {
            return Promise.reject(error)
        });
    }
}